/**
 * The different states/pages the app may be in.
 */
export enum SwipeDirection {
    LeftToRight = 4,
    RightToLeft = 2,
    UpToDown = 1,
    DownToUp = 3
}
